<template>
  <div>
    <main-nav />
    <div class="landingpage-goal-container">
      <div class="landingpage-goal-inner-container">
        <div class="landingpage-goal-wrapper">
          <h1 class="landingpage-goal-header">
            {{ $t('gen_ai.landingpage_goal.header.text') }}
          </h1>

          <div
            v-for="(goal, index) in goals"
            :key="index"
            class="landingpage-goal-card-wrapper"
          >
            <cvt-goal-card
              :header-text="goal.text"
              :icon="goal.icon"
              :is-active="selectedGoal === goal.goal"
              :value="goal.goal"
              @click="(value) => onClickGoalCard(value)"
            >
            </cvt-goal-card>
          </div>
        </div>
      </div>
      <hr />
      <div class="landingpage-goal-wrap">
        <div class="landingpage-goal-inner-btn-wrap">
          <cvt-button
            class="landingpage-goal-btn skip"
            :text="$t('gen_ai.landingpage_goal.skip_btn.text')"
            shape="round"
            color="light"
            :prepend="false"
            @click="handleSkip"
          ></cvt-button>

          <cvt-button
            class="landingpage-goal-btn continue"
            :text="$t('custom_domain.ui.unlink_dialog.buttons.continue')"
            shape="round"
            color="primary"
            icon="arrow-right"
            :disabled="disabled"
            :prepend="false"
            @click="handleOnClick"
          ></cvt-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { cvtRouteNodes } from '../../utils/routes'
import { setSessionGenAiOnboarding } from './utils'

export default {
  props: {},
  data() {
    return {
      disabled: true,
      selectedGoal: '',
      goals: [
        {
          id: 0,
          icon: 'folder',
          text: this.$t('gen_ai.landingpage_goal.option.collect_more_leads'),
          goal: 'collect-more-leads',
          isActive: true,
        },
        {
          id: 1,
          icon: 'shopping-cart',
          text: this.$t('gen_ai.landingpage_goal.option.follow_up_with_leads'),
          goal: 'follow-up-with-leads',
          isActive: false,
        },
        {
          id: 2,
          icon: 'users',
          text: this.$t(
            'gen_ai.landingpage_goal.option.get_referrals_and_business',
          ),
          goal: 'get-referrals-and-business',
          isActive: false,
        },
      ],
      sectionError: {
        isSectionValid: false,
        msg: '',
      },
    }
  },
  methods: {
    handleOnClick() {
      if (this.sectionError.isSectionValid) {
        setSessionGenAiOnboarding('landingPageGoal', this.selectedGoal)

        this.$router.push({
          name: cvtRouteNodes.genAIIntent,
        })
      }
    },
    handleSkip() {
      setSessionGenAiOnboarding('landingPageGoal', '')
      this.$router.push({
        name: cvtRouteNodes.genAIIntent,
      })
    },
    onClickGoalCard(goal) {
      this.validateSection(goal)
      this.selectedGoal = goal
    },
    validateSection(selectedGoal) {
      if (!selectedGoal) {
        this.disabled = true
        this.sectionError.msg = 'Select a goal'
        this.sectionError.isSectionValid = false
      } else {
        this.disabled = false
        this.sectionError.isSectionValid = true
      }
    },
  },
}
</script>
<style lang="scss">
@import './styles/LandingPageGoal.style.scss';
</style>
